import { writable } from 'svelte/store'

function createDataStore(data = [], idFuntionGenerator = null) {
    const { subscribe, set, update } = writable([])
    const index = new Set()
    const count = () => index.size
    const verifyId = (id) => !index.has(id)

    const getId = (item = null) => {
        if (idFuntionGenerator) {
            return idFuntionGenerator(item)
        } else {
        }
        let id = count() + 1
        while (!verifyId(id)) {
            id += 1
        }
        return id
    }

    const add = (inp) => {
        let { id, ...data } = inp
        id = id && verifyId(id) ? id : getId(inp)
        index.add(id)
        inp = { id, ...data }
        update((rows) => [...rows, inp])
        return inp
    }

    // Load store
    data.forEach((item) => {
        add(item)
    })

    return {
        set(data) {
            index.clear()
            set([])
            data.forEach((item) => {
                add(item)
            })
        },
        subscribe,
        add,
        delete(id) {
            index.delete(id)
            update((item) => item.filter((x) => (x?.id ? id !== x.id : true)))
        },
        sort({ key = (x) => x, asc = true }) {
            let ord = asc ? 1 : -1
            let ret
            let func = typeof key === 'function' ? key : (x) => x[key]
            update((item) => {
                ret = item.sort((a, b) =>
                    func(a) > func(b) ? ord * 1 : -1 * ord
                )
                return ret
            })
            return ret
        },
        get: (id) => {
            let ret
            if (index.has(id)) {
                subscribe((rows) => (ret = rows.find((x) => x.id === id)))
            }
            return ret
        },
        filter(func) {
            let obj = []
            subscribe((rows) => (obj = rows))
            return obj.filter(func)
        },
        update(id, data) {
            update((item) =>
                item.map((msg) =>
                    msg?.id ? (msg.id === id ? { ...msg, ...data } : msg) : msg
                )
            )
        },
        forceRefresh() {
            update((item) => [...item])
        },
        drop() {
            set([])
        },
        count() {
            return index.size
        },
        exists(id) {
            return index.has(id)
        },
        get value() {
            let ret
            subscribe((r) => (ret = r))
            return ret
        },
    }
}

export default createDataStore
